import En from "./privacy/En";

export default function Privacy({language}){
    language = language.slice(0, 2).toLowerCase();
    switch (language){
        case "des":
            return(
                <div>
                    {language}
                </div>
            );
        default:
            return(
                <En differentLang={language !== "en"}/>
            )
    }
}